import React, { useEffect, useMemo, useState } from "react";
import PaginationBootstrap from "react-bootstrap/Pagination";
import {
  buildPaginationItems,
  getPaginationInnerLimit,
  isPaginationEllipsis
} from "../../app/helpers/paginationRangeHelper";

const Pagination = ({
  totalPages,
  totalItems = 0,
  currentPage = 1,
  itemsPerPage = 10,
  onPageChange
}) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches
  );

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return undefined;
    }
    const media = window.matchMedia("(max-width: 768px)");
    const onChange = (event) => setIsMobile(event.matches);
    if (media.addEventListener) {
      media.addEventListener("change", onChange);
    } else {
      media.addListener(onChange);
    }
    setIsMobile(media.matches);
    return () => {
      if (media.removeEventListener) {
        media.removeEventListener("change", onChange);
      } else {
        media.removeListener(onChange);
      }
    };
  }, []);

  const innerLimit = getPaginationInnerLimit(isMobile);
  const safeTotal = Math.max(0, Number(totalPages) || 0);
  const safeCurrent = Math.min(Math.max(1, Number(currentPage) || 1), Math.max(safeTotal, 1));

  const paginationItems = useMemo(
    () => buildPaginationItems(safeCurrent, safeTotal, innerLimit),
    [safeCurrent, safeTotal, innerLimit]
  );

  const goTo = (page) => {
    if (typeof onPageChange !== "function") {
      return;
    }
    if (page < 1 || page > safeTotal || page === safeCurrent) {
      return;
    }
    onPageChange(page);
  };

  if (safeTotal === 0) {
    return null;
  }

  return (
    <PaginationBootstrap size="md" className="pagination-ellipsis mb-0">
      <PaginationBootstrap.First onClick={() => goTo(1)} disabled={safeCurrent === 1} />
      <PaginationBootstrap.Prev onClick={() => goTo(safeCurrent - 1)} disabled={safeCurrent === 1} />
      {paginationItems.map((item) => (
        isPaginationEllipsis(item) ? (
          <PaginationBootstrap.Ellipsis key={item} disabled />
        ) : (
          <PaginationBootstrap.Item
            key={item}
            active={item === safeCurrent}
            onClick={() => goTo(item)}
          >
            {item}
          </PaginationBootstrap.Item>
        )
      ))}
      <PaginationBootstrap.Next
        onClick={() => goTo(safeCurrent + 1)}
        disabled={safeCurrent === safeTotal}
      />
      <PaginationBootstrap.Last
        onClick={() => goTo(safeTotal)}
        disabled={safeCurrent === safeTotal}
      />
    </PaginationBootstrap>
  );
};

export default Pagination;
